import { profileMenus } from "../../assets/data/application/profile-menus";
import Icon from "../../assets/icons";
import { AppDispatch, RootState } from "../../store";
import { Avatar, Popover } from "@radix-ui/themes";
// import Image from "next/image";
// import Link from "next/link";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ProfileMenu from "./ProfileMenu";
import Menu from "./Menu";
import SearchBar from "./SearchBar";
import { BsBell } from "react-icons/bs";
import Notifications from "../notifications/Notification";
import {
  deleteNotification,
  getNotifications,
  markNotificationAsRead,
} from "../../store/reducers/notification";
import { useEffect, useState } from "react";

const DesktopNavBar = () => {

  const { user } = useSelector((state: RootState) => state.auth)
  const profilePhoto = useSelector((state: RootState) => state.auth.profilePhoto);

  const { totalUnread } = useSelector((state: RootState) => state.notification);
  const [profileImage, setProfileImage] = useState(profilePhoto);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(getNotifications(6));
  }, []);

  useEffect(() => {
    if (profilePhoto) {
      setProfileImage(profilePhoto)
    }
  }, [profilePhoto]);


  return (
    <div className="h-16 w-full flex px-10">
      <div className="w-full flex space-x-16">
        <div className="flex">
          <span className="sr-only">Viliyo</span>
          <img width={100} height={50} src={Icon.logo} alt="Viliyo Logo" />
        </div>
        <div className="flex space-x-8">
          <Menu href="/dashboard" title="Dashboard" icon={Icon.dashboard} />
          <Menu href="/task-list" title="Pending Tasks" icon={Icon.pendingTask} />
          {/* <Menu href="/calendar" title="Calendar" icon={Icon.calendar} /> */}
          {/* <Menu href="/history" title="History" icon={Icon.clock} /> */}
        </div>
      </div>
      <div className="w-full flex flex-row-reverse items-center my-auto space-x-8 space-x-reverse">
        <Popover.Root>
          <Popover.Trigger>
            <div className="w-fit h-fit cursor-pointer">
              <Avatar height={100} width={50} variant="solid" color="iris" src={profileImage} size="3" fallback={(user?.firstName ? user.firstName.charAt(0) : '') + (user?.lastName ? user.lastName.charAt(0) : '')} ></Avatar>
            </div>
          </Popover.Trigger>
          <Popover.Content style={{ width: 360 }} className="p-0">
            <ProfileMenu menus={profileMenus} />
          </Popover.Content>
        </Popover.Root>

        <Popover.Root>
          <Popover.Trigger>
            {/* <div className="flex -space-x-4">
              <BsBell color="white" className={`h-8 w-8`}></BsBell>
              {totalUnread > 0 ? (
                <div
                  className={`bg-red-600 flex justify-center items-center rounded-full text-xs border border-white  text-white h-5 w-5`}
                >
                  {totalUnread}
                </div>
              ) : (
                <div></div>
              )}
            </div> */}
          </Popover.Trigger>
          <Popover.Content style={{ width: 360 }} className="h-fit p-0 min-h-[400px] mr-16">
            <Notifications />
          </Popover.Content>
        </Popover.Root>

        <Link className="text-white text-[16px]" to="../help">
          Help
        </Link>
        {/* <SearchBar /> */}
      </div>
    </div>
  );
};


export default DesktopNavBar;